var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptometryVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "57px",
    viewBox: "0 0 73 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Optometry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Optometry Icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9728,41.5829 C24.9728,48.4099 19.4378,53.9439 12.6118,53.9439 C5.7848,53.9439 0.2498,48.4099 0.2498,41.5829 C0.2498,34.7559 5.7848,29.2219 12.6118,29.2219 C19.4378,29.2219 24.9728,34.7559 24.9728,41.5829 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7824,41.5829 C69.7824,48.4099 64.2484,53.9439 57.4214,53.9439 C50.5944,53.9439 45.0594,48.4099 45.0594,41.5829 C45.0594,34.7559 50.5944,29.2219 57.4214,29.2219 C64.2484,29.2219 69.7824,34.7559 69.7824,41.5829 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9728,41.5829 C24.9728,41.5829 34.6298,31.1529 45.0598,41.5829",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0973,33.6058 C3.0973,33.6058 11.8383,6.0438 12.6113,3.7268 C13.3843,1.4088 18.7923,-5.5442 18.7923,10.6798",
    id: "Stroke-7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7917,33.6058 C66.7917,33.6058 58.0507,6.0438 57.2777,3.7268 C56.5047,1.4088 51.0967,-5.5442 51.0967,10.6798",
    id: "Stroke-9",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptometryVertical);
export default __webpack_public_path__ + "static/media/optometry-vertical.6a7900a570436a15669c31941d912887.svg";
export { ForwardRef as ReactComponent };